import { Injectable, OnDestroy, inject } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { DashboardCallsService } from '../services/dashboard-calls.service';
import { Subscription, Observable, Subject, Observer } from 'rxjs';
import { ModalServiceService } from '../services/modal-service.service';
import { FolioValuePipe } from '../_pipes/folio-value.pipe';
import { SnackBarService } from '../services/snack-bar.service';
import { SendMetricService } from '../services/send-metric.service';
import { UserInfoService } from '../services/user-info-service.service';
import { AdobeAnalyticsService } from './adobe-analytics/adobe-analytics.service';

declare let _bnmxData: any;
declare let bnmx_tms: any;

@Injectable({
  providedIn: 'root',
})
export class QuickLockService implements OnDestroy {
  private userInfoService = inject(UserInfoService);
  private sendMetricService = inject(SendMetricService);
  private accountservice = inject(DashboardCallsService);
  private modalService = inject(ModalServiceService);
  private snackBarService = inject(SnackBarService);
  private folioValuePipe = inject(FolioValuePipe);
  private adobeAnalyticsService = inject(AdobeAnalyticsService);

  private accountInstanceId: any = '';
  public flag = '';

  private quickLockCallSubscribe: Subscription = new Subscription();
  private accounListSubscribe: Subscription = new Subscription();

  public isLockedCard$ = new Subject<boolean>();

  modal: any;
  statusCard = false;
  productName = '';
  isDashboard = true;
  backendProductTypeCode = '';
  backendInstrumentTypeCode = '';

  ngOnDestroy(): void {
    if (this.quickLockCallSubscribe) {
      this.quickLockCallSubscribe.unsubscribe();
    }

    if (this.accounListSubscribe) {
      this.accounListSubscribe.unsubscribe();
    }
  }

  blockOrUnblockCard(
    instanceId: string | undefined,
    flag: string,
    fromDashboard = true,
    accountStatus = null,
  ) {
    const user_info: any = this.userInfoService.getUserInfo();
    this.accountInstanceId = instanceId;
    this.flag = flag;
    this.isDashboard = fromDashboard;
    const buttonsModal = [
      {
        action: () => {
          this.quicklockCall('close');
          this.modalService.close('quickLock');
          this.modalService.close('quickUnlock');
        },
        name: 'Cancelar',
      },
      {
        action: () => {
          this.quicklockCall('quicklock');
          this.modalService.close('quickLock');
          this.modalService.close('quickUnlock');
        },
        name: 'Solicitar',
        class: 'label-01 interactive-01 btn',
      },
    ];

    if (this.flag === 'block' && user_info) {
      try {
        _bnmxData = {
          PgID: 'MX|BNP3|MULTISALDOS|MODAL_BLOQUEO',
          custType: 'MX|BNP3|' + user_info.customerDetails.custType,
          toolType: 'BloqueoDeTarjeta',
          eventList: 'event17',
          language: 'ES',
          server: user_info.customerDetails.serverInfo,
        };
        _bnmxData.PgID = this.isDashboard
          ? _bnmxData.PgID
          : 'MX|BNP3|DETALLE_TDC|MODAL_BLOQUEO';
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        _bnmxData = {
          PgID: 'MX|BNP3|MULTISALDOS|MODAL_DESBLOQUEO',
          custType: 'MX|BNP3|' + user_info.customerDetails.custType,
          toolType: 'DesbloqueoDeTarjeta',
          eventList: 'event17',
          language: 'ES',
          server: user_info.customerDetails.serverInfo,
        };
        _bnmxData.PgID = this.isDashboard
          ? _bnmxData.PgID
          : 'MX|BNP3|DETALLE_TDC|MODAL_DESBLOQUEO';
      } catch (error) {
        console.log(error);
      }
    }

    try {
      if (flag === 'block') {
        this.modal = this.modalService.getModal('quickLock');
        this.modal.setButtons(buttonsModal);
        this.modalService.open('quickLock');
        // this.sendMetricService.sendInterationDetails('BloquearTarjeta');
        try {
          bnmx_tms.sendMetric();
        } catch (error) {
          console.log(error);
        }
      } else {
        this.modal = this.modalService.getModal('quickUnlock');
        this.modal.setButtons(buttonsModal);
        this.modalService.open('quickUnlock');
        // this.sendMetricService.sendInterationDetails('DesbloquearTarjeta');
        try {
          bnmx_tms.sendMetric();
        } catch (error) {
          console.log(error);
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  quicklockCall(event: string) {
    const user_info: any = this.userInfoService.getUserInfo();

    if (event === 'close') {
      this.accountInstanceId = '';
      try {
        this.sendMetricService.sendInterationDetails('Cancelar');
      } catch (err: any) {
        console.log(err.message);
      }
      this.flag = '';
    } else if (event === 'quicklock') {
      try {
        this.sendMetricService.sendInterationDetails('Solicitar');
      } catch (err: any) {
        console.log(err.message);
      }

      if (this.isDashboard && user_info) {
        try {
          _bnmxData = {
            PgID: 'MX|BNP3|MULTISALDOS',
            UserId: user_info.customerDetails.hashedCustomerIdLoginHashing,
            citiProducts: '',
            custType: 'MX|BNP3|' + user_info.customerDetails.custType,
            language: 'ES',
            pageCat: 'MX|BNP3|Dashboard',
            prodOfferType: 'CopsOffersData',
            toolType: '',
            eventList: 'event18',
            server: user_info.customerDetails.serverInfo,
          };
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          _bnmxData = {
            PgID: 'MX|BNP3|DETALLE_TDC',
            custType: 'MX|BNP3|' + user_info.customerDetails.custType,
            prodNameOrig:
              this.backendProductTypeCode +
              '-' +
              this.backendInstrumentTypeCode,
            toolType: '',
            eventList: 'event18',
            language: 'ES',
            server: user_info.customerDetails.serverInfo,
          };
        } catch (error) {
          console.log(error);
        }
      }

      try {
        this.quickLockCallSubscribe = this.accountservice
          .quickLock(this.accountInstanceId, this.flag)
          .subscribe((quickLockData: HttpResponse<string>) => {
            if (quickLockData.status === 200) {
              const quickLockDataJson = JSON.parse(
                /* @ts-ignore */
                quickLockData.body,
              ).responseDetails;
              const folio = quickLockDataJson.folio;
              const date = this.folioValuePipe.transform(
                quickLockDataJson.folio,
              );
              this.statusCard =
                quickLockDataJson.cardStatus === 'LOCK' ? true : false;
              const txtStatusCard = this.statusCard
                ? 'bloqueada'
                : 'desbloqueada';
              var textLocked = this.statusCard ? 'Blocked' : 'Unblocked';

              this.isLockedCard$.next(this.statusCard);

              this.snackBarService.show(
                `Tu tarjeta está ${txtStatusCard} ${date} h <br>
                       Folio: ${folio}`,
              );
              if (this.flag === 'block') {
                try {
                  _bnmxData.citiProducts = this.productName + '-' + textLocked;
                  _bnmxData.toolType = 'BloqueoExitoso';
                } catch (error) {
                  console.log(error);
                }
              } else {
                try {
                  _bnmxData.citiProducts = this.productName + '-' + textLocked;
                  _bnmxData.toolType = 'DesbloqueoExitoso';
                } catch (error) {
                  console.log(error);
                }
              }

              try {
                bnmx_tms.sendMetric();
              } catch (error) {
                console.log(error);
              }

              this.accounListSubscribe = this.accountservice
                .getaccountList()
                .subscribe((data: any) => {
                  if (data?.status === 200) {
                    try {
                      this.accountInstanceId = '';
                      this.flag = '';
                      this.accountservice.setData(data);
                    } catch (e) {
                      window.location.href = '/MXGCB/apps/logout/flow.action';
                    }
                  } else {
                    window.location.href = '/MXGCB/apps/logout/flow.action';
                  }
                });
            } else {
              var textLocked = this.flag === 'block' ? 'Blocked' : 'Unblocked';
              if (this.flag === 'block') {
                try {
                  _bnmxData.toolType = 'BloqueoFallido';
                } catch (error) {
                  console.log(error);
                }
              } else {
                try {
                  _bnmxData.toolType = 'DesbloqueoFallido';
                } catch (error) {
                  console.log(error);
                }
              }
              try {
                _bnmxData.citiProducts = this.productName + '-' + textLocked;
              } catch (error) {
                console.log(error);
              }
              this.snackBarService.show(
                `Lo sentimos por el momento no se puede ${this.statusCard ? 'bloquear' : 'desbloquear'} tu tarjeta. Por favor inténtalo más tarde.`,
                'warning',
              );

              try {
                bnmx_tms.sendMetric();
              } catch (error) {
                console.log(error);
              }
            }
          });
      } catch (e) {
        const textLocked = this.flag === 'block' ? 'Blocked' : 'Unblocked';
        if (this.flag === 'block') {
          try {
            _bnmxData.toolType = 'BloqueoFallido';
          } catch (error) {
            console.log(error);
          }
        } else {
          try {
            _bnmxData.toolType = 'DesbloqueoFallido';
          } catch (error) {
            console.log(error);
          }
        }
        try {
          _bnmxData.citiProducts = this.productName + '-' + textLocked;
        } catch (error) {
          console.log(error);
        }

        this.snackBarService.show(
          `Lo sentimos por el momento no se puede ${this.statusCard ? 'bloquear' : 'desbloquear'} tu tarjeta. Por favor inténtalo más tarde.`,
          'warning',
        );

        try {
          bnmx_tms.sendMetric();
        } catch (error) {
          console.log(error);
        }
      }
    }
  }
}
